import React from "react";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function CajaVacia(props) {
    return (
        //<div className={"contenedor-caja-vacia"}> le saque la clase al div de abajo
        <div>
            <div className="caja-vacia">
                <h2 className={"encabezado"}>{props.encabezado}</h2>
                <p className={"texto-grande"}>{props.titulo}</p>
                <p className={"descripcion"} >{props.descripcion}</p>
                {props.boton?.trim() && (<div className="boton">
                    <p className="texto">{props.boton}</p>
                    <ArrowForwardIcon
                        className="icono"
                        fontSize="small"
                        className="enlace-icono"/>
                </div>)}
            </div>
        </div>
    );
}

export default CajaVacia;